import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useAuthenticatedUser } from "~/hooks/useAuthenticatedUser";
import { useAuth0Login } from "~/hooks/useAuth0Login";
import { Spinner } from "~/components/ui/spinner";
import { hasPendingPostLogoutRedirect } from "~/lib/auth-recovery";

export const Route = createFileRoute("/")({
  component: HomeRedirect,
});

const loadingSpinner = (
  <div className="flex items-center justify-center min-h-screen">
    <Spinner className="size-8 text-brand-green-primary" />
  </div>
);

function HomeRedirect() {
  const { user, isLoading: isUserLoading, routing } = useAuthenticatedUser();
  const { isAuthenticated, isLoading: isAuthLoading } = useAuth0Login();

  const isLoading = isAuthLoading || isUserLoading;

  if (isLoading) {
    return loadingSpinner;
  }

  if (isAuthenticated && user) {
    return <Navigate to={(routing?.homePath ?? "/dashboard")} replace />;
  }

  // PostLogoutRedirector (providers.tsx) will consume the ph_post_logout_redirect
  // cookie and navigate to the correct login page. Show a spinner while that is
  // pending to prevent navigating to /signup and triggering a redirect loop.
  if (hasPendingPostLogoutRedirect()) {
    return loadingSpinner;
  }

  return <Navigate to="/signup" />;
}
